module.exports = __webpack_public_path__ + "img/jiandingdashi.3a55f83b.svg";